/**
 * Alpro (access transport) classification helpers.
 *
 * The transport chain terminates at a Metro node — what the source data
 * labels as "FO Existing" is surfaced to users as "Metro" everywhere.
 */

export type AlproKind = 'metro' | 'radio' | 'other'

export function getAlproKind(type?: string | null): AlproKind {
  if (!type) return 'other'
  const val = String(type).toLowerCase()
  if (val.includes('metro') || val.includes('fo')) return 'metro'
  if (val.includes('radio')) return 'radio'
  return 'other'
}

/** True when this link/node terminates on the Metro backbone. */
export function isMetro(type?: string | null): boolean {
  return getAlproKind(type) === 'metro'
}

/** User-facing label — "FO Existing" is always shown as "Metro". */
export function getAlproLabel(type?: string | null): string {
  const kind = getAlproKind(type)
  if (kind === 'metro') return 'Metro'
  if (kind === 'radio') return 'Radio IP'
  return type ? String(type) : 'Other'
}

export const ALPRO_COLORS: Record<AlproKind, string> = {
  metro: '#22d3ee',
  radio: '#f97316',
  other: '#64748b',
}

export function getAlproColor(type?: string | null): string {
  return ALPRO_COLORS[getAlproKind(type)]
}
